import {
  ActivityNames,
  CaseReport,
  CaseReportTotals
} from './CaseTypes';
import { ChartDataItem } from './ChartTypes';
import { formatTimeDisplay, getActivityLabel } from '../utils/caseUtils';

/**
 * Formats CaseReport data for the legacy Case Efficiency component views.
 *
 * @deprecated This class is deprecated and should be removed after the v1.2 transition.
 * Use StepBreakdownAdapter for new chart components.
 */
export default class CaseEfficiencyViewModel {
  caseReport: CaseReport;

  constructor(caseReport: CaseReport) {
    this.caseReport = caseReport;
  }

  /**
   * @deprecated Use StepBreakdownAdapter.getStepBreakdownData() instead.
   */
  getActivityEfficiencyViewModel = (): ChartDataItem[] => {
    if (!this.caseReport.totals) {
      return [];
    }
    const totals: CaseReportTotals = this.caseReport.totals;
    const opTime = [];

    if (totals.exposure_time && totals.exposure_time > 0) {
      opTime.push({
        name: getActivityLabel(ActivityNames.EXPOSURE),
        time: totals.exposure_time,
        displayTime: formatTimeDisplay(totals.exposure_time)
      });
    }

    if (totals.total_cannulation_screw_placement_time && totals.total_cannulation_screw_placement_time > 0) {
      opTime.push({
        name: getActivityLabel(ActivityNames.CANNULATION_SCREW_PLACEMENT),
        time: totals.total_cannulation_screw_placement_time,
        displayTime: formatTimeDisplay(totals.total_cannulation_screw_placement_time)
      });
    }

    if (totals.alignment_decompression_time && totals.alignment_decompression_time > 0) {
      opTime.push({
        name: getActivityLabel(ActivityNames.DECOMPRESSION_ALIGNMENT),
        time: totals.alignment_decompression_time,
        displayTime: formatTimeDisplay(totals.alignment_decompression_time)
      });
    }

    if (totals.closure_time && totals.closure_time > 0) {
      opTime.push({
        name: getActivityLabel(ActivityNames.CLOSURE),
        time: totals.closure_time,
        displayTime: formatTimeDisplay(totals.closure_time)
      });
    }

    if (totals.post_cannulation_activity && totals.post_cannulation_activity > 0) {
      opTime.push({
        name: getActivityLabel(ActivityNames.POST_CANNULATION),
        time: totals.post_cannulation_activity,
        displayTime: formatTimeDisplay(totals.post_cannulation_activity)
      });
    }

    return opTime;
  };

  /**
   * Helper function to get the correct key from timeData.totals based on the step name.
   *
   * @deprecated This method is deprecated and should be removed after the v1.2 transition.
   */
  getSegmentTotalsKeyByLabel = (stepName: string): string => {
    switch (stepName) {
    case getActivityLabel(ActivityNames.CANNULATION_SCREW_PLACEMENT):
      return 'total_cannulation_screw_placement_time';
    case getActivityLabel(ActivityNames.CLOSURE):
      return 'closure_time';
    case getActivityLabel(ActivityNames.DECOMPRESSION_ALIGNMENT):
      return 'alignment_decompression_time';
    case getActivityLabel(ActivityNames.EXPOSURE):
      return 'exposure_time';
    case getActivityLabel(ActivityNames.POST_CANNULATION):
      return 'post_cannulation_activity';
    default:
      return stepName;
    }
  };
}
